// ============================================================================
// openCaseDetail — bridge from Pool/Cases row click → globally-mounted modal
// ============================================================================
// The Pre-Lit Case Detail is now an XL modal mounted globally in main_layout
// (not a tabbed module). Pool/Cases row clicks dispatch a dedicated window
// CustomEvent that main_layout listens for and toggles the modal open with
// the supplied caseId. We still stash the id in sessionStorage as a
// reference/diagnostic; readCaseDetailIdFromSession is kept for any callers
// that consume it.

const CASE_DETAIL_EVENT = 'recsuit:open-case-detail-modal';
const SESSION_KEY = 'prelit:caseDetailId';

export function openCaseDetail(caseId: string | number): void {
  try {
    sessionStorage.setItem(SESSION_KEY, String(caseId));
  } catch {
    /* sessionStorage unavailable (e.g. SSR / private mode) — skip; main_layout
       reads caseId straight off the event detail. */
  }
  window.dispatchEvent(
    new CustomEvent(CASE_DETAIL_EVENT, {
      detail: { caseId: String(caseId) },
    }),
  );
}

export function readCaseDetailIdFromSession(): string | null {
  try {
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

export function clearCaseDetailIdFromSession(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

// ---------------------------------------------------------------------------
// Account Cases bridge (ACCT-CASES-001)
// ---------------------------------------------------------------------------
const ACCT_CASES_MODULE_ID = 'account-cases';
const ACCT_CASES_SESSION_KEY = 'acct:casesAccountId';

export function openAccountCases(accountId: string | number): void {
  try {
    sessionStorage.setItem(ACCT_CASES_SESSION_KEY, String(accountId));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent('recsuit:open-screen', {
      detail: { moduleId: ACCT_CASES_MODULE_ID, params: { accountId: String(accountId) } },
    }),
  );
}
